import { initTopPageEffects } from "../pages/top";
import { initWorksDetailPageEffects } from "../pages/works-detail";
import { initContactPageEffects } from "../pages/contact";

export const initPageEffects = (page?: string | null): void => {
  if (page === "top") {
    initTopPageEffects();
  }

  if (page === "works-detail") {
    initWorksDetailPageEffects();
  }

  if (page === "contact") {
    initContactPageEffects();
  }
};
